import { render, staticRenderFns } from "./FormRenderRow.vue?vue&type=template&id=c0f4e486&scoped=true"
import script from "./FormRenderRow.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRenderRow.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f4e486",
  null
  
)

export default component.exports